import { Link, useLocation } from "react-router-dom";
import { routeTo } from "router";
import { Svg404 } from "@itwin/itwinui-illustrations-react";
import { NonIdealState } from "@itwin/itwinui-react";

export const SandboxNotFoundView = () => {
  const location = useLocation();
  const state = location.state as any;

  if (!state)
    return <NonIdealState svg={<Svg404 />} />;

  return (
    <NonIdealState
      svg={<Svg404 />}
      heading={`Sandbox "${state.sandboxName}" was not found`}
      description={
        <>
          We can not find the sandbox created by <Link to={routeTo.search(state.userName)} className="iui-anchor">{state.userName}</Link>.
          <br />
          It could be renamed or removed. Click on the author name to browse other sandboxes.
        </>
      }
    />
  )
};